/** Column accent colours from the POC — index cycles for any column count. */
export const COLUMN_ACCENTS = [
  '#1463ff',
  '#0f9f6e',
  '#d97706',
  '#6757e8',
  '#0891b2',
  '#db2777',
  '#65a30d',
  '#475569',
] as const;

export function columnAccent(index: number): string {
  return COLUMN_ACCENTS[index % COLUMN_ACCENTS.length]!;
}
